import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CancelButtonProps extends ButtonProps {
  onClick?: () => void;
}

export const CancelButton: React.FC<CancelButtonProps> = ({
  onClick,
  disabled,
  className,
  children,
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "w-full sm:w-auto h-9 rounded-lg bg-white ring-1 ring-neutral-200 font-light text-neutral-700 hover:bg-neutral-50 hover:text-neutral-900",
        className
      )}
      {...props}
    >
      {children || "Cancel"}
    </Button>
  );
};
